import {
  SEARCH_PARAM_CDF,
  SEARCH_PARAM_COMPONENT_ID,
  SEARCH_PARAM_INSPECTION_ID,
  SEARCH_PARAM_UNIT_ID,
} from 'routes/(common_search_params)/-searchParams'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_PREFERRED_ENDPOINT = 'preferredEndpoint'

/**
 * Search params accepted by the `/viewer-routing` dispatcher.
 *
 * Callers supply whatever identifiers they have on hand (a unit, an inspection,
 * and/or a component) and the dispatcher figures out which viewer page to land
 * the user on. Each id param is named for the entry type it carries; everything
 * is optional so a single link target can be reused from many call sites.
 */
export const viewerRoutingSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
  [SEARCH_PARAM_ORG_ID]: z.string().optional(),
  [SEARCH_PARAM_UNIT_ID]: z.string().optional(),
  [SEARCH_PARAM_INSPECTION_ID]: z.string().optional(),
  [SEARCH_PARAM_COMPONENT_ID]: z.string().optional(),
  [SEARCH_PARAM_CDF]: z.string().optional(),
  [SEARCH_PARAM_PREFERRED_ENDPOINT]: z
    .enum(['inspection', 'configuration'])
    .optional(),
})

export type ViewerRoutingSearch = z.infer<typeof viewerRoutingSearchParams>
